import { getMumulLiveProfileStatus } from './getMumulLiveProfileStatus';
import { getMumulLiveCurrentCampaign } from './getMumulLiveCurrentCampaign';
import { getMumulLiveProfilePosts } from './getMumulLiveProfilePosts';

export const mumulLiveService = {
  getMumulLiveProfileStatus,
  getMumulLiveCurrentCampaign,
  getMumulLiveProfilePosts,
};
